import type { ReactNode } from "react";

export function EmptyState({
  icon,
  title,
  detail,
  action,
}: {
  icon?: ReactNode;
  title: string;
  detail?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-container border border-dashed border-border px-6 py-12 text-center">
      {icon ? <span className="text-ink-disabled">{icon}</span> : null}
      <p className="type-h4 text-ink">{title}</p>
      {detail ? <p className="type-support text-ink-secondary max-w-md">{detail}</p> : null}
      {action}
    </div>
  );
}
